export default {
	props: {
		'form': {
			required: false,
		},
		'id': {
			type: String,
			required: false
		},
		'name': {
			type: String,
			required: true
		},
		'showErrors' : {
			type: Boolean,
			default: true
		},
		'modelValue': {
			required: true
		},
	},
	emits: ['update:modelValue'],
	inheritAttrs: false,
	computed: {
		renderedId() {
			return this.id ?? this.name;
		},

		hasError() {
			if(!this.form) {
				return false;
			}
			return (this.form.errors[this.name] ?? null) != null;
		}
	},
	methods: {
		changeModelValue(event) {
			if(this.form) {
				delete this.form.errors[this.name];
			}
			this.$emit('update:modelValue', event.target.value);
		},

		changeModelValueTo(value) {
			if(this.form) {
				delete this.form.errors[this.name];
			}
			this.$emit('update:modelValue', value);
		}
	}
}